import Vue from 'vue'
import Router from 'vue-router'

import Main from '@/components/Main'
import EmptyCart from '@/components/EmptyCart'
// import Loader from '@/components/Loader'
import Order from '@/components/Order'
import Confirmation from '@/components/Confirmation'
import Help from '@/components/Help'
import LoginVerification from '@/components/LoginVerification'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/shop/:shopId/cart/:cartId?',
      component: Main,
      children: [
        {
          path: '',
          name: 'Order',
          component: Order
        },
        // {
        //   path: '',
        //   component: Loader,
        // },
      ]
    },
    {
      path: '/shop/:shopId/order/:order_number',
      name: 'Confirmation',
      component: Confirmation,
    },
    {
      path: '/shop',
      name: 'NoShop',
      component: EmptyCart,
    },
    {
      path: '/help',
      name: 'Help',
      component: Help
    },
    {
      path: '/verify',
      component: LoginVerification,
    },

    { path: '/', redirect: '/shop' },
    { path: '*', redirect: '/shop' }
  ]
})
